import * as React from "react";
import { useSelector } from "react-redux";
import { connect } from "react-redux";
import PdfView from "../components/PdfView";
import { styles } from "../theme/styles";

function PDF(props) {
  const storedIdNumber = localStorage.getItem("IdNumber");
  const IdNumber =
    useSelector((state) => state.users.idNumber) || storedIdNumber;

  return (
    <div style={styles.content}>
      <PdfView />
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    userData: state.users.data,
  };
};

const creators = {};

export default connect(mapStateToProps, creators)(PDF);
